import { takeLatest } from 'redux-saga/effects';
import {
	getApplicantListSuccess, getApplicantListFail,
    getRecruitmentStatSuccess, getRecruitmentStatFail,
	getApplicantDetailsSuccess, getApplicantDetailsFail,
	getApplicantScoreSuccess, getApplicantScoreFail, 
	getPipelineStatsSuccess, getPipelineStatsFail,
} from './recruitmentState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, LOADING_MSG, UPDATING_MSG, updateRecordSuccess,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recruitment');
const redirectData = {route:'/console/job-roles', mode: 'list', recordId:0 };
const modelName = 'Applicant';
const modelId = 'jro_id';

function* getApplicantList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('job-applicants', data.payload), 
		getApplicantListSuccess, 
		getApplicantListFail, null, null, LOADING_MSG);
}

function* getRecruitmentStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/recruitment-stats', data.payload), 
		getRecruitmentStatSuccess, 
		getRecruitmentStatFail, null, null, LOADING_MSG);
}

function* getApplicantDetails(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/recruitment-stats', data.payload), 
		getRecruitmentStatSuccess, 
		getRecruitmentStatFail, null, null, LOADING_MSG);
}

function* doAdvanceApplicant(data){
	const { id, pipelineId } = data.payload;
	yield doCrudCall(
		() => crudService.doPostRequest(`job-applicant/${id}/advance/${pipelineId}`, null), 
		getApplicantDetailsSuccess, 
		getApplicantDetailsFail, 
		updateRecordSuccess(modelName), 
		{...redirectData, mode: "reload" }, 
		UPDATING_MSG);
}

function* doDeclineApplicant(data){
	const { id, pipelineId } = data.payload;
	yield doCrudCall(
		() => crudService.doPostRequest(`job-applicant/${id}/decline`, null), 
		getApplicantDetailsSuccess, 
		getApplicantDetailsFail, 
		updateRecordSuccess(modelName), 
		{...redirectData, mode: "reload" }, 
		UPDATING_MSG);
}

function* getApplicantScore(data){
	const { id, score } = data.payload;
	if(score){
		yield doCrudCall(
			() => crudService.doGetRequest(`job-applicant/${id}/generated-score`, null), 
			getApplicantDetailsSuccess, 
			getApplicantDetailsFail, 
			null, 
			null, 
			UPDATING_MSG);
	}else{
		yield doCrudCall(
			() => crudService.doPostRequest(`job-applicant/${id}/generate-score`, null), 
			getApplicantDetailsSuccess, 
			getApplicantDetailsFail, 
			null, 
			null, 
			UPDATING_MSG);
	}
	
}

function* getPipelineStats(data){
	const { id, ...rest } = data.payload;
	yield doCrudCall(
		() => crudService.doGetRequest(`statistics/job-request/${id}/pipeline-stats`, rest), 
		getPipelineStatsSuccess, 
		getPipelineStatsFail, null, null, LOADING_MSG);
}

function* recruitmentSaga() {
	yield takeLatest('recruitment/getApplicantList', getApplicantList);
	yield takeLatest('recruitment/getRecruitmentStat', getRecruitmentStat);
	yield takeLatest('recruitment/getApplicantDetails', getApplicantDetails);
	yield takeLatest('recruitment/doAdvanceApplicant', doAdvanceApplicant);
	yield takeLatest('recruitment/doDeclineApplicant', doDeclineApplicant);
	yield takeLatest('recruitment/getApplicantScore', getApplicantScore);
	yield takeLatest('recruitment/getPipelineStats', getPipelineStats);
}

export default recruitmentSaga;